/**
 * subject-context-search-result-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link SubjectContextRequest} when requesting a
 * particular indexable from an index record set provided to the client in a
 * {@link SubjectContextSearchResponse}. The server responds with an {@link
 * SubjectContextResponse} that carries the opaque identifier for the
 * requested object.
 */
export class SubjectContextSearchResultRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SUBJECT_CONTEXT_SEARCH_RESULT;
	public static tag : MessageTag = MessageTag.REQ_SUBJECT_CONTEXT_SEARCH_RESULT;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }

  /**
   * Construct a new {@link SubjectContextRequest}.
   */
  constructor (public recordId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/search/subject-context-search-result-request.ts